import { render, staticRenderFns } from "./TabPreciosDesdePlano.vue?vue&type=template&id=c5c90ff8"
import script from "./TabPreciosDesdePlano.vue?vue&type=script&lang=js"
export * from "./TabPreciosDesdePlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports